<svelte:options tag={null} />

<script lang="ts">
  import type {
    NotificationTitleTag,
    NotificationType,
    NotificationSize,
  } from './notification.types';
  import { EventHandler } from '../../utilities/EventHandler';

  export let title: string;
  export let titletag: NotificationTitleTag = 'h3';
  export let alert = false;
  export let href: string;
  export let linkcontent: string;
  export let type: NotificationType;
  export let closable = false;
  export let size: NotificationSize = 'm';
  export let hasfooter = false;

  $: attributes = { ...$$restProps };
  $: delete attributes.class;

  let eventHandler = new EventHandler();

  function setClasses(
    type: NotificationType,
    size: NotificationSize,
    closable: boolean,
  ): string {
    const classes = ['mc-notification'];

    if (type) {
      classes.push(`mc-notification--${type}`);
    }

    if (size && size !== 'm') {
      classes.push(`mc-notification--${size}`);
    }

    if (closable) {
      classes.push('mc-notification-closable');
    }

    return classes.join(' ');
  }

  function emitClose(e: CustomEventInit): void {
    eventHandler.dispatch('close', e);
  }
</script>

<div
  class="{setClasses(type, size, closable)} {$$props.class}"
  role={alert ? 'alert' : undefined}
  {...attributes}
>
  <div class="mc-notification__content">
    {#if title}
      {@html `<${titletag} class="mc-notification__title">${title}</${titletag}>`}
    {/if}
    <div class="mc-notification__message">
      <slot />
    </div>
    {#if href && linkcontent}
      <div class="mc-notification__footer">
        <a class="mc-notification__link mc-link" {href}>{linkcontent}</a>
      </div>
    {:else if hasfooter}
      <div class="mc-notification__footer">
        <slot name="footer" />
      </div>
    {/if}
  </div>
  {#if closable}
    <button
      type="button"
      class="mc-notification-closable__close"
      title="Close"
      on:click={emitClose}
    />
  {/if}
</div>

<style lang="scss">
  @import '@mozaic-ds/styles/settings-tools/_all-settings';
  @import '@mozaic-ds/styles/components/_c.links';
  @import '@mozaic-ds/styles/components/_c.notification';
</style>
